import api from "./axios";

export const searchUsers = async (query) => {
  const response = await api.get(`/api/community/search/?q=${query}`);
  return response.data;
};

export const getFriendsList = async () => {
  const response = await api.get("/api/community/friends/");
  return response.data;
};

export const getPendingRequests = async () => {
  const response = await api.get("/api/community/requests/");
  return response.data;
};

export const sendFriendRequest = async (userId) => {
  const response = await api.post(`/api/community/send-request/${userId}/`);
  return response.data;
};

export const respondFriendRequest = async (friendshipId, action) => {
  const response = await api.post(`/api/community/requests/${friendshipId}/respond/`, { action });
  return response.data;
};

export const getGlobalLeaderboard = async () => {
  const response = await api.get("/api/community/leaderboard/");
  return response.data;
};

export const getUserProfile = async (userId) => {
  const response = await api.get(`/api/community/profile/${userId}/`);
  return response.data;
};

// AI Investor Agents
export const getAgents = async () => {
  const response = await api.get("/api/community/agents/");
  return response.data;
};

export const getAgentDetail = async (agentId) => {
  const response = await api.get(`/api/community/agents/${agentId}/`);
  return response.data;
};

// Matchmaking
export const getMatches = async (type = "similar", includeAgents = true) => {
  const response = await api.get("/api/community/match/", {
    params: { type, include_agents: includeAgents ? 1 : 0 },
  });
  return response.data;
};

// Stock Drafts
export const listDrafts = async () => {
  const response = await api.get("/api/community/drafts/");
  return response.data;
};

export const createDraft = async (payload) => {
  const response = await api.post("/api/community/drafts/", payload);
  return response.data;
};

export const getDraft = async (draftId) => {
  const response = await api.get(`/api/community/drafts/${draftId}/`);
  return response.data;
};

export const joinDraft = async (draftId) => {
  const response = await api.post(`/api/community/drafts/${draftId}/join/`);
  return response.data;
};

export const startDraft = async (draftId) => {
  const response = await api.post(`/api/community/drafts/${draftId}/start/`);
  return response.data;
};

export const makeDraftPick = async (draftId, symbol) => {
  const response = await api.post(`/api/community/drafts/${draftId}/pick/`, { symbol });
  return response.data;
};
